import { render, staticRenderFns } from "./List.vue?vue&type=template&id=b27f0c56&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./styles/list.scss?vue&type=style&index=0&id=b27f0c56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f0c56",
  null
  
)

export default component.exports